import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { RouterModule } from '@angular/router';
import { ActionButtonModule } from '../../notes/action-button/action-button.module';

import { ButtonModule } from '../../notes/button/button.module';
import { IconModule } from '../../notes/icon/icon.module';
import { ModalModule } from '../../notes/modal/modal.module';
import { ModelAttributeModule } from '../../notes/model-attribute/model-attribute.module';
import { FormGroupModule } from '../form-group/form-group.module';

import { LinkModule } from '../link/link.module';
import { ButtonsComponent } from './components/buttons/buttons.component';
import { ContactUsComponent } from './components/contact-us/contact-us.component';
import { DropdownComponent } from './components/dropdown/dropdown.component';
import { ExpandableMenuComponent } from './components/expandable-menu/expandable-menu.component';
import { LanguageDropdownComponent } from './components/language-dropdown/language-dropdown.component';
import { LinksComponent } from './components/links/links.component';
import { MobileLanguageSwitcherComponent } from './components/mobile-language-switcher/mobile-language-switcher.component';
import { MobileMenuComponent } from './components/mobile-menu/mobile-menu.component';
import { NavIconsComponent } from './components/nav-icons/nav-icons.component';
import { ToolbarComponent } from './components/toolbar/toolbar.component';

import { NavigationComponent } from './navigation.component';
import { IsLinkActivePipe } from './pipes/is-link-active/is-link-active.pipe';

@NgModule({
  declarations: [
    NavigationComponent,
    ToolbarComponent,
    LinksComponent,
    NavIconsComponent,
    MobileMenuComponent,
    ContactUsComponent,
    ButtonsComponent,
    ExpandableMenuComponent,
    LanguageDropdownComponent,
    MobileLanguageSwitcherComponent,
    DropdownComponent,
    IsLinkActivePipe,
  ],
  imports: [
    ReactiveFormsModule,
    MatSelectModule,
    CommonModule,
    RouterModule,
    IconModule,
    ModalModule,
    LinkModule,
    ButtonModule,
    ModelAttributeModule,
    ActionButtonModule,
    FormGroupModule,
  ],
  exports: [
    NavigationComponent,
    MobileMenuComponent,
    IsLinkActivePipe,
    LanguageDropdownComponent,
  ],
})
export class NavigationModule {}
